const ru = {
  // Navbar
  nav_home: "Главная",
  nav_about: "О Тентен-Одзисан",
  nav_services: "Услуги и цены",
  nav_flow: "Как это работает",
  nav_testimonials: "Отзывы",
  nav_faq: "Часто задаваемые вопросы",
  nav_contact: "Контакт",
  nav_cta: "Записаться на чтение",
  nav_subtitle: "Чтение имён · Окинава",
  nav_title: "Гадание Тентен-Одзисан",

  // Hero
  hero_headline1: "На тихом острове",
  hero_headline2: "Окинавы",
  hero_headline3: "услышь голос",
  hero_headline4: "своего имени.",
  hero_body: "Популярное чтение имён с очередью на несколько месяцев.\nКаждый месяц я лично отправляюсь на остров\nи передаю ваше имя мастеру.",
  hero_pill1: "Без смены имени",
  hero_pill2: "100% онлайн",
  hero_pill3: "Доставка за 1 месяц",
  hero_pill4: "Первые 100 в месяц",
  hero_btn_apply: "Записаться на чтение",
  hero_btn_services: "Посмотреть услуги",
  hero_scroll: "ПРОКРУТИТЬ",

  // About
  about_heading: "О Тентен-Одзисан",
  about_intro: "На тихом острове <strong>Икэй-дзима</strong>, окружённом мягким морем Окинавы,\nживёт человек, который тихо добавляет немного света в каждое имя.\nЛюди ласково называют его <strong>«Тентен-Одзисан»</strong>.",
  about_block1_label: "От банкира к чтецу имён",
  about_block1_text: "Тентен-Одзисан изначально был банкиром.\nБлагодаря своему усердию он стал <strong>самым молодым управляющим отделением</strong> в своей компании.\nРаботая со многими людьми, в его сердце возник вопрос.",
  about_block1_quote: "«Почему некоторые люди словно плывут по ветру, хотя все работают одинаково усердно?»",
  about_block1_sub: "Этот маленький вопрос стал началом великого путешествия открытий.",
  about_block2_label: "Древние знания и тихое откровение",
  about_block2_text: "Он посвящал каждую свободную минуту изучению древних текстов о чтении имён, тщательно исследуя количество черт традиционных иероглифов и звуковой поток.",
  about_block2_text2: "Он понял, что <strong>«тен-тен (знаки озвончения) могут тихо гармонизировать поток имени».</strong>",
  about_block2_sub: "Это была не драматическая магия и не броская формула успеха,\nа мягкий путь, делающий более видимым свет, который уже существует в человеке.",
  about_block3_label: "Сарафанное радио — теперь 6 месяцев ожидания",
  about_block3_text: "Его мягкие чтения распространились исключительно через сарафанное радио, и теперь <strong>запросы приходят со всей Японии</strong>.\nЗнаменит он или нет — к каждому человеку он относится с одинаковой заботой.\nОн кладёт руку на каждое имя и сопровождает жизнь этого человека.\nТаков стиль Тентен-Одзисан.",

  // Gallery
  gallery_heading: "Галерея",
  gallery_sub: "Окинава · Остров Икэй",

  // Services
  services_heading: "Услуги и цены",
  services_note1: "※ Все тарифы включают гонорар мастера и наш сервис представительства на месте.",
  services_note2: "※ Никаких дополнительных расходов. Смело доверяйтесь нам.",
  services_tab1: "Личное имя",
  services_tab2: "Название бизнеса",
  services_tab3: "Имя питомца",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Мы мягко наблюдаем за вашим ростом, окружением и движениями сердца, и добавляем идеальный тен-тен именно для вас.",
  services_tab2_desc: "Мягкий попутный ветер для новых вызовов. Тихая гармонизация потока вашего бизнеса.",
  services_tab3_desc: "Для члена семьи, который всегда рядом с вами. Мы дарим имя, полное покоя и тепла.",
  services_row1_target1: "16 лет и старше",
  services_row1_target2: "4–15 лет",
  services_row1_target3: "0–3 года",
  services_row2_target1: "Бизнес / Компания / Торговое название",
  services_row3_target1: "Имя питомца",
  services_col_target: "Целевая аудитория",
  services_col_price: "Цена (с НДС)",
  services_cta: "Заказать эту услугу",
  services_includes_title: "Что включено (всё в цене)",
  services_inc1: "Чтение имени",
  services_inc2: "Оптимальное предложение тен-тен",
  services_inc3: "Карточка в формате визитки по почте по запросу (бесплатно)",
  services_inc4: "Советы по удаче",
  services_inc5: "Цифровое фото карточки с именем",
  services_includes_note: "Чтение, чтобы мягко подчеркнуть очарование, которое уже существует в вашем имени.",
  services_payment_title: "Оплата",
  services_payment_method: "Банковский перевод (предоплата)",
  services_payment_desc: "Мы предоставим банковские реквизиты после вашей заявки.\nКак только оплата будет завершена, поток удачи начнёт тихо выстраиваться.",
  services_first_title: "Для новых посетителей",
  services_first_desc: "Естественно чувствовать неуверенность.\nЭто чувство — сигнал вашего сердца\nо том, что пора начать мягкие перемены.",
  services_first_cta: "Начать с консультации",

  // Flow
  flow_heading: "Как это работает",
  flow_step1_title: "Отправить форму заявки",
  flow_step1_c1: "Пожалуйста, заполните необходимую информацию в специальной форме.",
  flow_step1_c2: "После отправки вы получите ответное письмо в течение 2–3 рабочих дней.",
  flow_step1_c3: "В письме будут указаны следующие шаги и инструкции по банковскому переводу.",
  flow_step2_title: "Перевести оплату за чтение",
  flow_step2_c1: "Пожалуйста, переведите оплату за чтение на счёт, указанный в ответном письме.",
  flow_step2_c2: "После подтверждения мы начнём подготовку вашего чтения по очереди.",
  flow_step3_title: "Уведомить нас о переводе",
  flow_step3_c1: "После перевода отправьте фото квитанции на адрес, указанный в письме.",
  flow_step3_c2: "После подтверждения мы отправим вам сообщение «Регистрация завершена».",
  flow_step3_note: "Без этого уведомления мы можем не начать ваше чтение. Обязательно отправьте его.",
  flow_step4_title: "Получить результаты чтения",
  flow_step4_c1: "Примерно через неделю после чтения мы отправим вам по электронной почте фото карточки с именем и тен-тен.",
  flow_step4_c2: "Затем мы отправим подробный отчёт о чтении и советы по удаче по электронной почте.",
  flow_step5_title: "Отправка карточки с именем (по желанию)",
  flow_step5_c1: "По запросу мы отправляем карточку, написанную от руки мастером, в формате визитки.",
  flow_step5_c2: "Пожалуйста, укажите точный почтовый адрес в поле адреса формы заявки.",
  flow_step5_note: "Если карточка не нужна, достаточно указать ваш город.",
  flow_banner_title: "Полностью онлайн. Из любой точки Японии.",
  flow_banner_desc: "Не нужно ехать на остров Икэй на Окинаве.\nВы можете начать прямо сейчас, не меняя свой распорядок дня.",
  flow_banner_cta: "Подать заявку сейчас",

  // Testimonials
  testimonials_heading: "Отзывы",
  testimonials_viewing: "Просматривается",

  // FAQ
  faq_heading: "Часто задаваемые вопросы",
  faq_cta_title: "Есть ещё вопросы?",
  faq_cta_desc: "Даже маленькие вопросы приветствуются.\nВопросы, которые вы стесняетесь задать — именно их мы хотим услышать.",
  faq_cta_btn: "Спросить нас",

  // CTA Banner
  cta_heading1: "Бесплатная",
  cta_heading2: "консультация",
  cta_btn: "Записаться сейчас",

  // Contact
  contact_heading: "Контакт",
  contact_desc: "Свяжитесь с нами через эту форму для заявок на чтение или вопросов. Обычно мы отвечаем в течение 2–3 рабочих дней.",
  contact_address_label: "Адрес",
  contact_address_value: "Тотиги, Япония (Онлайн · По всей стране)",
  contact_email_label: "Электронная почта",
  contact_hours_label: "Часы работы",
  contact_hours_value: "Пн–Пт 9:00–18:00 (Сб/Вс/Праздники закрыто)",
  contact_note_title: "Об ответах",
  contact_note_desc: "Наш ответ может попасть в папку со спамом.\nЕсли вы не получили ответ в течение 2–3 рабочих дней, свяжитесь с нами напрямую по электронной почте.",
  contact_field_name: "Полное имя",
  contact_field_furigana: "Фуригана (чтение)",
  contact_field_email: "Адрес электронной почты",
  contact_field_phone: "Номер телефона",
  contact_field_service: "Желаемая услуга",
  contact_field_message: "Сообщение",
  contact_placeholder_name: "Иванов Иван",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+7 000 000 0000",
  contact_placeholder_message: "Пожалуйста, введите имя, которое вы хотите прочитать, или ваши вопросы и пожелания.",
  contact_select_placeholder: "Пожалуйста, выберите",
  contact_service1: "Личное имя",
  contact_service2: "Название бизнеса",
  contact_service3: "Имя питомца",
  contact_service4: "Другое / Консультация",
  contact_submit: "Отправить",
  contact_submitting: "Отправка...",
  contact_privacy: "Личные данные, отправленные через форму, будут использоваться исключительно для услуг чтения.",
  contact_error: "Ошибка отправки. Пожалуйста, попробуйте позже или свяжитесь с нами напрямую по электронной почте.",
  contact_err_name: "Пожалуйста, введите ваше имя",
  contact_err_email_required: "Пожалуйста, введите адрес электронной почты",
  contact_err_email_invalid: "Пожалуйста, введите действительный адрес электронной почты",
  contact_err_service: "Пожалуйста, выберите услугу",
  contact_err_message_required: "Пожалуйста, введите ваше сообщение",
  contact_err_message_limit: "Пожалуйста, ограничьте сообщение 500 символами",
  contact_thanks_title: "Сообщение отправлено",
  contact_thanks_desc: "Спасибо за обращение.\nМы рассмотрим ваше сообщение и ответим в течение <strong>2–3 рабочих дней</strong>.\nПожалуйста, немного подождите.",
  contact_thanks_check1: "Пожалуйста, проверьте подтверждающее письмо",
  contact_thanks_check2: "Также проверьте папку со спамом",
  contact_thanks_check3: "Пожалуйста, ожидайте ответа 2–3 рабочих дня",
  contact_thanks_another: "Отправить ещё одно сообщение",

  // Footer
  footer_subtitle: "Чтение имён · Окинава",
  footer_title: "Гадание Тентен-Одзисан",
  footer_desc: "Из Окинавы по всей Японии. Мастер чтения имён с более чем 50-летним опытом внимательно читает судьбу в вашем имени.",
  footer_contact_title: "КОНТАКТНАЯ ИНФОРМАЦИЯ",
  footer_address_label: "АДРЕС",
  footer_address_value: "Тотиги, Япония\n(Онлайн · По всей стране)",
  footer_email_label: "ПОЧТА",
  footer_hours_label: "ЧАСЫ РАБОТЫ",
  footer_hours_value: "Пн–Пт 9:00–18:00\n(Сб/Вс/Праздники закрыто)",
  footer_nav_title: "НАВИГАЦИЯ",
  footer_copyright: "© 2025 Гадание Тентен-Одзисан. Все права защищены.",
  footer_privacy: "Политика конфиденциальности",
  footer_law: "Закон об особых коммерческих сделках",
  footer_sitemap: "Карта сайта",
};

export default ru;
